export const SELECT_CHANNEL_INDEX = 'REPAYMENTS/SELECT_CHANNEL_INDEX'
